import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';
import { Content } from './styles/Content';

export const NoOrgsPage = () => {
  const { openModal } = useModalContext();
  const { me } = useAuthContext();
  const canCreateOrganizations = me.canCreateOrganizations !== false;

  const openCreateOrganizationModal = () => {
    openModal(ModalNamesEnum.NewOrganizationModal);
  };

  return (
    <Content>
      <div className="content">
        It looks like you {"don't"} belong to any organization.
        <br />
        {canCreateOrganizations ? (
          <>
            Create your own organization to continue.
            <Button type="button" onClick={() => openCreateOrganizationModal()}>
              Create Organization
            </Button>
          </>
        ) : (
          <>Your account is managed by your company single sign-on. Ask your administrator for workspace access.</>
        )}
      </div>
    </Content>
  );
};
